import { HYDRATE } from 'next-redux-wrapper';

import { THydrateAction } from '~/src/store';

export enum ETvPackagesActionTypes {
    GET_PACKAGES = 'GET_PACKAGES',
    SET_PACKAGES = 'SET_PACKAGES',
    ERROR_PACKAGES = 'ERROR_PACKAGES',
    SET_TRIAL_PACKAGE = 'SET_PACKAGE',
}

export enum EChannelQuality {
    HD = 'HD',
    SD = 'SD',
}

export enum ETryAndBuyDurationTypeId {
    MONTHS = 1,
    DAYS = 5,
}

export interface ITheme {
    id: number,
    title: string,
}

export interface IPackageTheme extends ITheme {
    packets: ITvPackage[],
}

export interface ICostRa {
    cost: number,
    duration: number,
    durationTypeId: number,
    groups: number[],
    raId: number,
}

export interface ITvPackageState {
    actDateTo: number | null,
    dateFrom: number | null,
    dateOff: number | null,
    dateTo: number | null,
    duration: number | null,
    platform: string,
    prolong: number | null,
    unsetFrom: number | null,
    unsetState: number,
}

interface ITryAndBuy {
    cost: number,
    discount: number,
    duration: number,
    durationTypeId: ETryAndBuyDurationTypeId,
    raId: number,
}

export interface ITvPackage {
    id: number,
    active: number,
    alias: string,
    baseCost?: number,
    channelsCount: number,
    channelsCountHd: number,
    cost: number,
    costRa?: ICostRa[],
    description: string,
    image: string,
    name: string,
    state?: ITvPackageState,
    themes: ITheme[],
    tryAndBuy: ITryAndBuy | null,
    weight: number,
    channels: Array<{[key: string]: any }>,
    [key: string]: unknown,
}

interface IEpgChannel {
    quality: EChannelQuality,
    [key: string]: unknown,
}

export interface IEpgTvPacket {
    id: string,
    alias: string,
    body: string,
    channels: IEpgChannel[],
    image680x280: string,
    price: number,
    themes: ITheme[],
    title: string,
    weight: number,
    [key: string]: unknown,
}

interface ITvPackagesState {
    fetching: boolean,
    fetchError: string | null,
    allPackages: IEpgTvPacket[],
    connectedInTariff: ITvPackage[],
    connectedOutTariff: ITvPackage[],
    canConnect: ITvPackage[],
    trialPackage: ITvPackage | null,
    terminalId?: number,
}

const initialState: ITvPackagesState = {
    fetching: false,
    fetchError: null,
    allPackages: [],
    connectedInTariff: [],
    connectedOutTariff: [],
    trialPackage: null,
    canConnect: [],
};

export type TActions = {
    type: ETvPackagesActionTypes,
    payload: Partial<ITvPackagesState>,
};

export default function reducer(state = initialState, action: TActions | THydrateAction): ITvPackagesState {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.tvPackages };
        case ETvPackagesActionTypes.GET_PACKAGES:
        case ETvPackagesActionTypes.SET_PACKAGES:
        case ETvPackagesActionTypes.ERROR_PACKAGES:
        case ETvPackagesActionTypes.SET_TRIAL_PACKAGE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
